const legacyCatalogSlugMap: Record<string, string> = {
  'vga-intel': 'vga',
  ssd: 'ssd-nvme',
  case: 'case-gaming',
  'vo-may': 'case-gaming',
  'thung-may': 'case-gaming',
  nguon: 'nguon-may-tinh',
  psu: 'nguon-may-tinh',
  keyboard: 'ban-phim',
  mouse: 'chuot',
  headset: 'tai-nghe',
  switch: 'switch-mang',
  printer: 'may-in',
  camera: 'camera-trong-nha',
};

function normalizeRawSlug(input: string) {
  return String(input || '')
    .trim()
    .toLowerCase()
    .replace(/^\/+|\/+$/g, '');
}

export function normalizeCatalogSlug(input: string) {
  const raw = normalizeRawSlug(input);
  return legacyCatalogSlugMap[raw] || raw;
}

export function isLegacyCatalogSlug(input: string) {
  const raw = normalizeRawSlug(input);
  return Boolean(raw && legacyCatalogSlugMap[raw] && legacyCatalogSlugMap[raw] !== raw);
}

export function getCatalogPublicHref(input: string) {
  const slug = normalizeCatalogSlug(input);
  return slug ? `/danh-muc/${slug}` : '/';
}
